module.exports = __webpack_public_path__ + "static/media/no-fav.6b01c502.png";